module.exports = __webpack_public_path__ + "static/sc_3-5bf529e789325c13a2c05e3ec8a728de.jpg";